import {useKeyboardControls} from '@react-three/drei'
import { useEffect } from 'react'
import { useContext } from 'react'
import { GeometryContext } from '../store/store'
import {useSelector, useDispatch} from 'react-redux'
import interfaceSlice from '../store/interfaceSlice'
import { useRef } from 'react'
import {addEffect} from '@react-three/fiber'

const Interface = () => {

    // const storeCtx = useContext(GeometryContext)
    const {forward, backward, leftward, rightward, jump} = useKeyboardControls((state)=> state)
    const dispatch = useDispatch()
    const {interface:interfaceState}  = useSelector((state)=>state)
    const {onRestart} = interfaceSlice.actions

    const timeRef = useRef()

    useEffect(()=>{
        const unsubscribeEffect = addEffect(()=>{
            let elapsedTime = 0

            if(interfaceState.phase === 'playing'){
                elapsedTime = Date.now() - interfaceState.startTime
            }else if(interfaceState.phase === 'ended'){
                elapsedTime = interfaceState.endTime - interfaceState.startTime
            }
            elapsedTime /= 1000
            if(timeRef.current){
                timeRef.current.textContent = elapsedTime.toFixed(2)
            }
        })
        return ()=>{
            unsubscribeEffect()
        }
    },[interfaceState.phase])
    
    const restartHandler = (event) =>{
        dispatch(onRestart())
    }
  

    return (
        <div className='interface'>
            <div className="time" ref={timeRef}>
                0.00
            </div>
            {interfaceState?.phase === 'ended' && 
                <div className="restart" onClick={restartHandler}>Restart</div>
            }
            <div className="controls">
                <div className="raw">
                    <div className={`key ${forward && 'active'}`}>W</div>
                </div>
                <div className="raw">
                    <div className={`key ${leftward && 'active'}`}>A</div>
                    <div className={`key ${backward && 'active'}`}>S</div>
                    <div className={`key ${rightward && 'active'}`}>D</div>
                </div>
                <div className="raw">
                    <div className={`key large ${jump && 'active'}`}>SPACE</div>
                </div>
            </div>
        </div>
    )
}

export default Interface